export default "__VITE_ASSET__BLSTj0cP__"